import { render } from "./FormComponent.vue?vue&type=template&id=47adf8c1"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=47adf8c1&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__